import type { Color } from "../color";
import { colorFactory } from "../color-factory";
import type { HexColor } from "../hex-color/hex-color";
import { parseCssHex } from "../parce-css-hex";
import { rgbaToHsla } from "./rgba-to-hsla";

const hexToColor = (hex: HexColor): Color => {
    const rgba = parseCssHex(hex);
    // console.log("HEX TO COLOR", { hex, rgba, hsla: rgbaToHsla(rgba) });
    return colorFactory(rgbaToHsla(rgba));
};
export { hexToColor };
